import { memo } from 'react';

import { Checkbox } from '@shared/ui/Checkbox';

import cls from './CheckboxListItem.module.scss';

type ListItemProps = {
  onChange: (value: boolean, label: string) => void;
  label: string;
  active: boolean;
};

export const CheckboxListItem = memo(({ onChange, label, active }: ListItemProps) => {
  const onChangeHandler = (checked: boolean) => {
    onChange(checked, label);
  };

  return (
    <Checkbox
      onChange={onChangeHandler}
      label={label}
      className={cls.checkbox}
      value={active}
      testId={'filter-checkbox'}
    />
  );
});
